import React from "react";
import "./StatsSection.css";

const StatsSection = () => {
  return (
    <div className="stats-container">
      <div className="stat-card">
        <h2>7 Cr+</h2>
        <p>E-Way Bills Extended</p>
      </div>

      <div className="stat-card">
        <h2>8.5 Cr+</h2>
        <p>Total E-Way Bills Processed</p>
      </div>

      <div className="stat-card">
        <h2>35+</h2>
        <p>Active Transport Clients</p>
      </div>

      <div className="stat-card">
        <h2>99.9%</h2>
        <p>Client Satisfaction Rate</p>
        <small className="stat-subtext">0 Penalties Charged</small>
      </div>
    </div>
  );
};

export default StatsSection;
